// Textos do painel de Acessibilidade (namespace "accessibility"), registrados
// à parte para não mexer na lista grande de src/i18n.js.
import i18n from '../i18n';
import pt from '../locales/pt/accessibility.json';
import en from '../locales/en/accessibility.json';
import es from '../locales/es/accessibility.json';
import de from '../locales/de/accessibility.json';
import fr from '../locales/fr/accessibility.json';
import it from '../locales/it/accessibility.json';
import zh from '../locales/zh/accessibility.json';

export const NAMESPACE = 'accessibility';
const pacotes = { pt, en, es, de, fr, it, zh };

Object.entries(pacotes).forEach(([idioma, pacote]) => {
  if (!i18n.hasResourceBundle(idioma, NAMESPACE)) {
    i18n.addResourceBundle(idioma, NAMESPACE, pacote, true, false);
  }
});

export default i18n;
